module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.media.track) ? _c('div', {
    class: {
      showing: _vm.media.showing
    }
  }, [_c('div', [_vm._v("displayName: " + _vm._s(_vm.media.displayName))]), _vm._v(" "), _c('div', [_vm._v("id: " + _vm._s(_vm.media.id))]), _vm._v(" "), _c('div', [_vm._v("peerId: " + _vm._s(_vm.media.peerId))]), _vm._v(" "), _c('div', [_vm._v("codec: " + _vm._s(_vm.media.codec))]), _vm._v(" "), _c('div', [_vm._v("type: " + _vm._s(_vm.media.type))]), _vm._v(" "), _c('div', [_vm._v("track: " + _vm._s(_vm.media.track && _vm.media.track.id))]), _vm._v(" "), _c('div', [_vm._v("deviceId: " + _vm._s(_vm.media.deviceId))]), _vm._v(" "), _c('div', [_vm._v("browser: " + _vm._s(_vm.media.mediaDetails))]), _vm._v(" "), (_vm.media.track) ? _c('div', [_c('button', {
    attrs: {
      "data-media-id": _vm.media.id
    },
    on: {
      "click": _vm.show
    }
  }, [_vm._v(_vm._s(_vm.media.showing ? 'hide' : 'show'))])]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-550358e8","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/items/Media.vue
// module id = 716
// module chunks = 1